import { UserService } from 'app/client-core/services/user.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SiteMenuModel } from 'app/client-core/dtos/site-menu.model';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() menu: SiteMenuModel;
  @Output() menuItemClicked = new EventEmitter();

  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {

  }

  haveClaims (): boolean {
    if (this.menu.resourceName && this.menu.claimName) {
      const claims = this.userService.getCachedClaimsList();
      const claim = claims.find(r => r.operation === this.menu.claimName && r.resource === this.menu.resourceName);
      return claim !== null && claim !== undefined;
    }
    return true;
  }

  menuClicked() {
    console.log(this.menu);
    if (location.href.replace(location.origin + '/#', '') == this.menu.navLink) {
      console.log('same route');
      location.reload();
      return;
    }
    this.menuItemClicked.emit(this.menu);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/menu-item/menu-item.component.ts